import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { RestapiService } from '../../services/restapi.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {MatAccordion} from '@angular/material/expansion';

@Component({
  selector: 'app-widgets-v2',
  templateUrl: './widgets-v2.component.html',
  styleUrls: ['./widgets-v2.component.scss']
})
export class WidgetsV2Component implements OnInit {

  @ViewChild('firstAccordion') firstAccordion: MatAccordion;
  selected: any;
  @Input() data: any;

  constructor(
    public api: RestapiService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    let newarr = this.data.websectiondata.sort((a, b) => a.order - b.order);
    this.data.websectiondata = newarr;

  }

  open(content, selected?) {
    this.selected = selected;
    console.log('selected', selected)
    this.modalService.open(content, { windowClass: "app-modal" });
  };

  expandAccordions() {
    this.firstAccordion.openAll();
  }
}
